var map = {
	"./AllChildrenArrow": 8990,
	"./AllChildrenArrow.js": 8990,
	"./ArrowDownIcon": 9635,
	"./ArrowDownIcon.js": 9635,
	"./ArrowForwardIcon": 3320,
	"./ArrowForwardIcon.js": 3320,
	"./ArrowLeftCircleIcon2": 4394,
	"./ArrowLeftCircleIcon2.js": 4394,
	"./ArrowRightCircleIcon": 6735,
	"./ArrowRightCircleIcon.js": 6735,
	"./ArrowRightCircleIcon2": 8057,
	"./ArrowRightCircleIcon2.js": 8057,
	"./BeImg": 895,
	"./BeImg.js": 895,
	"./BellImg": 9439,
	"./BellImg.js": 9439,
	"./Chip": 4109,
	"./Chip.js": 4109,
	"./CompleteLogo": 2391,
	"./CompleteLogo.js": 2391,
	"./CrossImg": 1292,
	"./CrossImg.js": 1292,
	"./DeleteIcon": 9421,
	"./DeleteIcon.js": 9421,
	"./DirectChildren": 3534,
	"./DirectChildren.js": 3534,
	"./DownBoldArrow": 1435,
	"./DownBoldArrow.js": 1435,
	"./DownImg": 6624,
	"./DownImg.js": 6624,
	"./FbImg": 1100,
	"./FbImg.js": 1100,
	"./LikesImg": 4636,
	"./LikesImg.js": 4636,
	"./LinkedInImg": 5714,
	"./LinkedInImg.js": 5714,
	"./Login.png": 2255,
	"./MailImg": 4329,
	"./MailImg.js": 4329,
	"./ParentHeirarichyImg": 5864,
	"./ParentHeirarichyImg.js": 5864,
	"./PendingImg": 9021,
	"./PendingImg.js": 9021,
	"./PinterestImg": 8114,
	"./PinterestImg.js": 8114,
	"./PlayButton": 7021,
	"./PlayButton.js": 7021,
	"./PointerIcon": 507,
	"./PointerIcon.js": 507,
	"./PostedImg": 9453,
	"./PostedImg.js": 9453,
	"./SSLLogo": 9810,
	"./SSLLogo.js": 9810,
	"./ScienceImg": 3410,
	"./ScienceImg.js": 3410,
	"./SearchSvg": 3493,
	"./SearchSvg.js": 3493,
	"./ShareImg": 3485,
	"./ShareImg.js": 3485,
	"./TwitterImg": 8281,
	"./TwitterImg.js": 8281,
	"./UpArrowInRedCircle": 5483,
	"./UpArrowInRedCircle.js": 5483,
	"./UpBoldArrow": 3632,
	"./UpBoldArrow.js": 3632,
	"./UserIcon": 6823,
	"./UserIcon.jsx": 6823,
	"./aboutUs2.jpg": 4076,
	"./aboutUsImages/AuthorsBenefits.png": 543,
	"./aboutUsImages/ClassificationsAndSubjects1.png": 2917,
	"./aboutUsImages/ClassificationsAndSubjects2.png": 5086,
	"./aboutUsImages/HowToHelpProject.png": 5956,
	"./aboutUsImages/HumanKnowledge.png": 9846,
	"./aboutUsImages/LittleScientists1.png": 5649,
	"./aboutUsImages/LittleScientists2.png": 8218,
	"./aboutUsImages/MethodsOfScience1.png": 2937,
	"./aboutUsImages/MethodsOfScience2.png": 8930,
	"./aboutUsImages/Motivation.png": 3667,
	"./aboutUsImages/MotivationCycle.png": 2657,
	"./aboutUsImages/Science.png": 8293,
	"./aboutUsImages/ScientificDiagram.png": 5817,
	"./aboutUsImages/StartingPoint.png": 253,
	"./aboutUsImages/TechBasis.png": 8329,
	"./aboutUsImages/TechnicsAndTechnology1.png": 939,
	"./aboutUsImages/TechnicsAndTechnology2.png": 9075,
	"./aboutUsImages/TechnologyExamples.png": 9716,
	"./aboutUsImages/TheIdea.png": 3955,
	"./aboutUsImages/ThroughScienceLenses1.png": 5111,
	"./aboutUsImages/ThroughScienceLenses2.png": 284,
	"./aboutUsImages/WhyBeneficial.png": 3029,
	"./arrowDownward.svg": 5294,
	"./arrowUpward.svg": 5661,
	"./bin.svg": 4348,
	"./directionArrowDown 2.svg": 8785,
	"./directionArrowUp.svg": 1252,
	"./doubleArrow.svg": 1213,
	"./dummyImages/AboutUs.png": 9463,
	"./dummyImages/AboutUs2.png": 4533,
	"./dummyImages/MathTitleImg.png": 1755,
	"./dummyImages/NoVideo.png": 8034,
	"./dummyImages/Steve.png": 5281,
	"./dummyImages/dummyImg.jpeg": 2504,
	"./dummyImages/logoWithBg.png": 5054,
	"./dummyImages/nextInCircle.png": 2096,
	"./dummyImages/securityExpert.png": 4008,
	"./female_icon.jpeg": 3868,
	"./graduatingHat": 5268,
	"./graduatingHat.js": 5268,
	"./hyperlink": 6797,
	"./hyperlink.js": 6797,
	"./logIn1.png": 2399,
	"./logo.png": 8374,
	"./male_icon.jpeg": 6139,
	"./motivatonLogo.png": 8299,
	"./motivatonLogo.svg": 8915,
	"./neutral_icon.jpeg": 2037,
	"./paper-background.png": 4964,
	"./peerReview": 519,
	"./peerReview.js": 519,
	"./search.png": 15,
	"./signIn": 8061,
	"./signIn.js": 8061,
	"./topicsImages/Topic-Algorithms-Thumbnail-png-2 1.png": 1999,
	"./topicsImages/Topic-Electricity-Thumbnail-png-2 1.png": 7964,
	"./topicsImages/Topic-MobileNetworks-Thumbnail-png-2 1.png": 6806,
	"./videosThumbnails/1_1_AddOn_1.png": 6119,
	"./videosThumbnails/1_1_AddOn_2.png": 8911,
	"./videosThumbnails/1_1_AddOn_3.png": 4181,
	"./videosThumbnails/1_1_AddOn_4.png": 6234,
	"./videosThumbnails/1_1_AddOn_5.png": 1459,
	"./videosThumbnails/1_1_AddOn_6.png": 4600,
	"./videosThumbnails/1_1_What_1.png": 1747,
	"./videosThumbnails/1_1_What_2.png": 6136,
	"./videosThumbnails/1_1_What_3.png": 7265,
	"./videosThumbnails/1_1_Why_1.png": 3684,
	"./videosThumbnails/1_1_Why_2.png": 6220,
	"./videosThumbnails/2_1_What_1.png": 6226,
	"./videosThumbnails/2_1_What_2.png": 4409,
	"./videosThumbnails/2_1_What_3.png": 7504,
	"./videosThumbnails/2_1_What_4.png": 351,
	"./videosThumbnails/2_1_Why_1.png": 5184,
	"./videosThumbnails/3_1_What_1.png": 2049,
	"./videosThumbnails/3_1_What_2.png": 1466,
	"./videosThumbnails/3_1_Why_1.png": 905,
	"./videosThumbnails/3_2_What_1.png": 120,
	"./videosThumbnails/3_2_Why_1.png": 1258
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6467;